// Internal modules
import { hasTreatment } from '@/lib/features/utils';
import { features } from '@/lib';

export const shouldRenderFields = (position?: string): boolean => {
  const shouldShowOptionalUpsellHalfSheet = features.hasFeature(
    'shouldShowOptionalUpsellHalfSheet',
  );
  const reorderExperiment =
    hasTreatment('FEATURE_ONBOARDING_OTP') || shouldShowOptionalUpsellHalfSheet;

  const isTop = position === 'top';

  return reorderExperiment ? isTop : !isTop;
};
